<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M1.9 6.8H5.31481L4.47735 9H1.9C1.40294 9 1 9.40294 1 9.9C1 10.3971 1.40294 10.8 1.9 10.8H3.79216L1.61683 16.5146C1.22399 17.5466 1.80095 18.3832 2.90552 18.3832H16.9055C18.0101 18.3832 19.224 17.5466 19.6168 16.5146L23.6443 5.93431C23.8408 5.41831 23.5523 5.00001 23 5.00001H12.1048L12.1 5H1.9C1.40294 5 1 5.40294 1 5.9C1 6.39706 1.40294 6.8 1.9 6.8ZM6.85346 8.01197L3.61683 16.5146H17.6168L20.8533 8.01229L14.2398 12.5703C12.6515 13.6649 10.752 13.6649 9.99712 12.5703L6.85346 8.01197ZM8.87252 6.83839H19.7282L13.3285 11.249C12.7991 11.6139 12.1659 11.6139 11.9143 11.249L8.87252 6.83839Z"
  />
</template>
